import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { HotlineClientCreateConfirmPage } from '@/feature/hotline/client/create/confirm/page/HotlineClientCreateConfirmPage';
import { useHotlineClientCreateFormContext } from '@/feature/hotline/client/create/context/HotlineClientCreateFormContext';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン投稿 確認
 * @description api データ取得を伴わないアクセス制限等を行う
 */
export const HotlineClientCreateConfirm = () => {
    const { formValues } = useHotlineClientCreateFormContext();
    // 入力画面に値がない場合はリダイレクト
    if (!formValues) {
        return _jsx(CustomRedirect, { to: pagePath.hotline.client.createInput() });
    }
    return _jsx(HotlineClientCreateConfirmPage, { formValues: formValues });
};
